import { Anchor, Group, Indicator, Stack, ThemeIcon, Title } from '@mantine/core';
// TODO: вернуть IconChecklist вместе с ACCREDITATION_STAGE_CHANGED, когда бэкенд добавит тип
import { IconBell, /* IconChecklist, */ IconClock, IconProps } from '@tabler/icons-react';
import cn from 'classnames';
import * as React from 'react';
import { Link } from 'react-router-dom';

import Text from 'components/shared/Text';
import { NotificationEntity, NotificationType } from 'entities/Notification';
import { formatDateIfCurrentYear } from 'utils/formatDateIfCurrentYear';

import { notificationLinkConfigMap } from './config';

import s from './Item.module.scss';

type ItemProps = {
  className?: string;
  data: NotificationEntity;
};

const typeIconMap: Record<NotificationType, React.FC<IconProps>> = {
  LEAD_EXP: IconClock,
  // ACCREDITATION_STAGE_CHANGED: IconChecklist,
  OTHER: IconBell,
};

const Item: React.FC<ItemProps> = ({ className, data }) => {
  const Icon = typeIconMap[data.type];
  const linkConfig = notificationLinkConfigMap[data.type];

  return (
    <Group wrap="nowrap" align="flex-start" className={cn(s.root, className)}>
      <Indicator disabled={data.read}>
        <ThemeIcon radius="md" size={36} variant="light">
          <Icon size={20} />
        </ThemeIcon>
      </Indicator>
      <Stack gap="xxxs">
        <Text size="md" c="gray">
          {formatDateIfCurrentYear(data.createdAt)}
        </Text>
        <Title order={4} size="h4">
          {data.title}
        </Title>
        <Text size="md" c="gray">
          {data.text}
        </Text>
        {linkConfig && (
          <Anchor component={Link} to={linkConfig.to(data)}>
            {linkConfig.label}
          </Anchor>
        )}
      </Stack>
    </Group>
  );
};

export default React.memo(Item);
